const API = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = 'portfolio-owner-token';

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (token) => localStorage.setItem(TOKEN_KEY, token);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const authHeaders = () => ({ Authorization: `Bearer ${getToken()}` });

const parseError = async (res) => {
  try {
    const data = await res.json();
    const detail = data?.detail;
    if (typeof detail === 'string') return detail;
    if (Array.isArray(detail)) return detail.map((e) => e?.msg || '').filter(Boolean).join(' ');
  } catch (e) { /* ignore */ }
  return 'Something went wrong. Please try again.';
};

export async function login(password) {
  const res = await fetch(`${API}/api/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ password }),
  });
  if (!res.ok) throw new Error(await parseError(res));
  const data = await res.json();
  setToken(data.token);
  return data;
}

export async function checkSession() {
  if (!getToken()) return false;
  try {
    const res = await fetch(`${API}/api/auth/me`, { headers: authHeaders() });
    return res.ok;
  } catch (e) {
    return false;
  }
}

export async function fetchWeekEntries(practicum, week) {
  const res = await fetch(`${API}/api/content/week/${practicum}/${week}`);
  if (!res.ok) return {};
  const data = await res.json();
  return data.entries || {};
}

export async function saveWeekEntries(practicum, week, entries) {
  const res = await fetch(`${API}/api/content/week/${practicum}/${week}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...authHeaders() },
    body: JSON.stringify({ entries }),
  });
  if (!res.ok) throw new Error(await parseError(res));
  return true;
}

export async function fetchPhotos(context) {
  const res = await fetch(`${API}/api/photos?context=${encodeURIComponent(context)}`);
  if (!res.ok) return [];
  return res.json();
}

export async function uploadPhoto(context, file) {
  const formData = new FormData();
  formData.append('file', file);
  const res = await fetch(`${API}/api/photos?context=${encodeURIComponent(context)}`, {
    method: 'POST',
    headers: authHeaders(),
    body: formData,
  });
  if (!res.ok) throw new Error(await parseError(res));
  return res.json();
}

export async function deletePhoto(id) {
  const res = await fetch(`${API}/api/photos/${id}`, {
    method: 'DELETE',
    headers: authHeaders(),
  });
  if (!res.ok) throw new Error(await parseError(res));
  return true;
}

export const fileUrl = (url) => (url && url.startsWith('http') ? url : `${API}${url}`);
